module.exports = __webpack_public_path__ + "img/table-5.f394e412.jpg";